<template>
  <v-menu
    v-model="dateMenu"
    ref="dateMenu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    offset-x
  >
    <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="dateFormatted"
          label="Date"
          hint="DD/MM/YYYY format"
          persistent-hint
          prepend-icon="mdi-calendar"
          v-bind="attrs"
          autocomplete="off"
          @blur="dateIsoStr = parseDate(dateFormatted)"
          v-on="on"
        ></v-text-field>        
    </template>
    <v-date-picker
      v-model="dateIsoStr"
      @input="dateMenu = false"
    ></v-date-picker>
  </v-menu>
</template>

<script>
export default {
  props: {
    date: {
      type: Date,
      default: new Date()
    }
  },
  created() {
    const dateObj = this.date || new Date();
    this.dateIsoStr = dateObj.toISOString().substr(0, 10);
    this.dateFormatted = this.formatDate(this.dateIsoStr);
  },
  data: () => ({
    dateMenu: false,
    dateIsoStr: "",
    dateFormatted: "",
  }),
  methods: {
    parseDate(date) {
      if (!date) return null;
      return new Date(this.$options.filters.parseSlashedDate(date));
    },
    formatDate(dateIsoStr) {
      if (!dateIsoStr) return null;
      return this.$options.filters.formatDate(dateIsoStr);
    },
  }, 
  watch: {
    dateIsoStr() {
      this.dateFormatted = this.formatDate(this.dateIsoStr);
      this.$emit('update:date', this.parseDate(this.dateFormatted));
    },
    date() {
      if (!this.date) {
        return;
      }
      this.dateIsoStr = this.date.toISOString().substr(0, 10);
      this.dateFormatted = this.formatDate(this.dateIsoStr);
    }
  },    
}
</script>

<style lang="scss" scoped>

</style>